/** @module Apparel/NewHierarchyForm */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/form/Widget"
], function (declare, _, Widget) {

	const CATEGORY1 = "Category1";
	const CATEGORY2 = "Category2";
	const COLLECTION = "Collection";
	const PARENT_SEASON = "ParentSeason";
	const SEASON = "Season";

	return declare(Widget, {
		/**@property {boolean} canProceed - indicates if can proceed to the next step in the case of wizard */
		canProceed: false,

		/**
		 * Preselect the hierarchy Fields based on the current node and style node if any
		 * @param {Node} currentNode - the current hierarchy node
		 * @param {Node} [sourceNode] - style node if any
		 */
		populateHierarchyField: function (currentNode, sourceNode) {
			const currentNodeUrl = currentNode.$URL;

			// other than site level, need preselect the fields
			if (!sourceNode) {
				switch (currentNode.$Type) {
					case SEASON:
						this.addFixedValue(PARENT_SEASON, currentNodeUrl);
						break;
					case CATEGORY1:
						this.addFixedValue(PARENT_SEASON, currentNode.ParentSeason);
						this.addFixedValue(CATEGORY1, currentNodeUrl);
						break;
					case CATEGORY2:
						this.addFixedValue(PARENT_SEASON, currentNode.ParentSeason);
						this.addFixedValue(CATEGORY1, currentNode.Category1);
						this.addFixedValue(CATEGORY2, currentNodeUrl);
						break;
					default:
						break;
				}
			} else {
				const { ParentSeason, Category1, Category2 } = sourceNode;
				const Collection = sourceNode.$URL;

				switch (currentNode.$Type) {
					case SEASON:
						this.addFixedValue(PARENT_SEASON, ParentSeason);
						this.addDefaultValue(CATEGORY1, Category1);
						this.addDefaultValue(CATEGORY2, Category2);
						this.addDefaultValue(COLLECTION, Collection);
						break;
					case CATEGORY1:
						this.addFixedValue(PARENT_SEASON, ParentSeason);
						this.addFixedValue(CATEGORY1, Category1);
						this.addDefaultValue(CATEGORY2, Category2);
						this.addDefaultValue(COLLECTION, Collection);
						break;
					case CATEGORY2:
						this.addFixedValue(PARENT_SEASON, ParentSeason);
						this.addFixedValue(CATEGORY1, Category1);
						this.addFixedValue(CATEGORY2, Category2);
						this.addDefaultValue(COLLECTION, Collection);
						break;
					default:
						this.addDefaultValue(PARENT_SEASON, ParentSeason);
						this.addDefaultValue(CATEGORY1, Category1);
						this.addDefaultValue(CATEGORY2, Category2);
						this.addDefaultValue(COLLECTION, Collection);
						break;
				}
				this.canProceed = true;
			}
		},

		/**
		 * @override
		 * Configure the Fields, also, preselect the Fields if any
		 */
		_resolveView: function () {
			// Force the Fields editable
			this.defView.m_fields.forEach(field => {
				field.bForceEditable = true;
				field.bDisableExpressionEvaluation = true;
			});

			this.inherited(arguments);
		},

		/**
		 * @override
		 * update the flag on validating the value of "Collection"
		 */
		_validateField: function (field, bSubset) {
			const result = this.inherited(arguments);

			if (field.getControlName() == COLLECTION) {
				this.canProceed = !result;

				// trigger the logic to disable the Actions on wizard accordingly
				this.viewParent.set("disabled", false);
			}

			return result;
		}
	});
});
